var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 922,
    height: 823,
    viewBox: "0 0 922 823",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.531 138.048H523.962L524.02 138.019L767.123 684.952H637.376H537.777C537.22 684.952 536.664 684.943 536.109 684.926C521.56 684.112 507.892 677.519 498.494 666.505C497.96 665.848 497.443 665.175 496.941 664.486C487.934 652.184 479.419 634.236 479.419 610.528C479.419 603.438 480.367 596.865 481.747 590.894C495.897 601.111 513.277 607.171 532.072 607.171L532.101 607.142C532.422 607.142 532.743 607.14 533.064 607.137C580.115 606.651 618.116 568.368 618.116 521.225C618.116 449.983 574.236 407.075 535.161 368.865C524.984 358.914 515.134 349.282 506.469 339.551C468.588 296.998 460.276 271.38 460.276 271.38C460.276 271.38 460.266 271.408 460.247 271.465C460.228 271.409 460.218 271.38 460.218 271.38C460.218 271.38 451.906 296.999 414.025 339.552C405.36 349.283 395.51 358.915 385.333 368.866C346.258 407.076 302.378 449.984 302.378 521.226C302.378 568.671 340.868 607.142 388.336 607.142C388.656 607.142 388.976 607.14 389.296 607.137C407.753 606.946 424.811 600.913 438.737 590.851C440.123 596.834 441.075 603.422 441.075 610.558C441.075 632.674 433.661 649.782 425.349 661.998C415.815 676.026 399.965 684.416 383.063 684.981C382.967 684.981 382.871 684.981 382.775 684.981H153.428L396.531 138.048Z",
    fill: "#004540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/Logomark.24d2b1509fe7803b20439c8b8e5087eb.svg";
export { ForwardRef as ReactComponent };